<mat-form-field [appearance]="appearance()" class="full-width">
  <mat-label>{{ label() }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="searchControl"
    [placeholder]="placeholder()"
    [required]="required()"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [autoActiveFirstOption]="autoActiveFirstOption()"
    (optionSelected)="onAddressSelected($event.option.value)"
  >
    @for (suggestion of suggestions(); track suggestion.formattedAddress) {
      <mat-option [value]="suggestion.formattedAddress">
        {{ suggestion.formattedAddress }}
      </mat-option>
    }
    @if (isLoading()) {
      <mat-option disabled>Laden...</mat-option>
    }
    @if (!isLoading() && suggestions().length === 0 && searchControl.value) {
      <mat-option disabled>Geen resultaten gevonden</mat-option>
    }
  </mat-autocomplete>
  @if (required() && searchControl.hasError('required') && searchControl.touched) {
    <mat-error>Dit veld is verplicht.</mat-error>
  }
  @if (errorMessage()) {
    <mat-error>{{ errorMessage() }}</mat-error>
  }
</mat-form-field>
